import {useContext} from 'react';

import {ConfirmContext} from '~ui/components/ConfirmProvider/ConfirmProvider';

export function useConfirm() {
    return useContext(ConfirmContext);
}
